import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import UnloadingExcel from '../../../pages/unloadings/unloadingExcel/unloadingExcel';
import SectionContent from '../../../components/sectionContent/sectionContent';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';
import { IUserOptions } from '../../../types/interfaces';

const AdminUnloadingExcelSection: FC = () => {
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent section='Заказанные документы' pageName='unloadings'>
				<div className='content__main'>
					<div className='btns'>

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:excel')) && <Link to='/unloadings/excel' className='tab'>
							<div className='buttons__btn --active'>Excel</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:zip')) && <Link to='/unloadings/zip' className='tab'>
							<div className='buttons__btn'>Zip</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('payrolls:view') || claims.includes('orders:payrolls')) && (
							<Link to='/unloadings/tables' className='tab'>
								<div className='buttons__btn'>Табели</div>
							</Link>
						)}

						{(claims.includes('admin') || claims.includes('payrolls:view') || claims.includes('orders:cron')) && (
							<Link to='/unloadings/cron' className='tab'>
								<div className='buttons__btn'>Cron</div>
							</Link>
						)}
						
						{(claims.includes('admin') || claims.includes('orders:import')) && <Link to='/unloadings/template' className='tab'>
							<div className='buttons__btn'>Загрузка шаблонов</div>
						</Link>}
					</div>
					<UnloadingExcel />
				</div>
			</SectionContent>
		</div>
	);
};

export default AdminUnloadingExcelSection;
